/**
 * Map CMS / API `lang.code` to a Vuetify short locale id for VDatePicker.
 * No static “supported locales” list — API is the source of truth; unknown codes fall back to `en`.
 */
export function resolveVuetifyLocale(code) {
    const raw = String(code || '').toLowerCase().trim();
    if (!raw) return 'en';
    const base = raw.replace('_', '-').split('-')[0] || 'en';
    const mapped =
        { cz: 'cs', dk: 'da', se: 'sv', gr: 'el', nb: 'no', nn: 'no' }[base] || base;
    return /^[a-z]{2,3}$/.test(mapped) ? mapped : 'en';
}
